var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var _a;
import * as React from "react";
import { BetBtnOdd } from "./BetBtnOdd";
import { BetBtnMlQa } from "./BetBtnMlQa";
import { BetBtnOuHc } from "./BetBtnOuHc";
// TODO: TYPE UP THE ADD TO BET SLIP FUNCTIONS
export var BetBtnTypes;
(function (BetBtnTypes) {
    BetBtnTypes["Odd"] = "bet_btn--Odd";
    BetBtnTypes["ML"] = "bet_btn--ML";
    BetBtnTypes["QA"] = "bet_btn--QA";
    BetBtnTypes["OU"] = "bet_btn--OU";
    BetBtnTypes["HC"] = "bet_btn--HC";
})(BetBtnTypes || (BetBtnTypes = {}));
var BetBtnsMap = (_a = {},
    _a[BetBtnTypes.Odd] = function (props) { return (React.createElement(BetBtnOdd, { odd: props.odd, dataUat: props.betButtonInnerDataUats })); },
    _a[BetBtnTypes.ML] = function (props) { return (React.createElement(BetBtnMlQa, { text: props.text, odd: props.odd, dataUat: props.betButtonInnerDataUats })); },
    _a[BetBtnTypes.QA] = function (props) { return (React.createElement(BetBtnMlQa, { text: props.text, odd: props.odd, dataUat: props.betButtonInnerDataUats })); },
    _a[BetBtnTypes.OU] = function (props) { return (React.createElement(BetBtnOuHc, { text: props.text, point: props.point, odd: props.odd, dataUat: props.betButtonInnerDataUats })); },
    _a[BetBtnTypes.HC] = function (props) { return (React.createElement(BetBtnOuHc, { text: props.text, point: props.point, odd: props.odd, dataUat: props.betButtonInnerDataUats })); },
    _a);
var BetBtn = /** @class */ (function (_super) {
    __extends(BetBtn, _super);
    function BetBtn() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.fnRouter = function () { return ((typeof _this.props.handler !== "function" ? _this.noop : _this.props.handler)()); };
        return _this;
    }
    BetBtn.prototype.noop = function () { return false; };
    BetBtn.prototype.render = function () {
        var cls = "bet_btn" + (this.props.modifier ? " " + this.props.modifier : "");
        var childrenFn = (this.props.type && typeof BetBtnsMap[this.props.type] === "function") ?
            BetBtnsMap[this.props.type] :
            BetBtnsMap[BetBtnTypes.Odd];
        return (React.createElement("button", { type: this.props.type, className: cls, onClick: this.fnRouter, disabled: this.props.isDisabled, "data-uat": this.props.dataUat }, childrenFn(this.props)));
    };
    return BetBtn;
}(React.Component));
export { BetBtn };
//# sourceMappingURL=BetBtn.js.map